import { Stack } from "@volca/ui/components/ui/stack";
import type { EnrichedResult } from "@/payroll/editor/types";

export const CheckProblems = ({ result }: { result: EnrichedResult }) => (
  <Stack gap={1} align="stretch">
    {result.issueGroups.map((group) => (
      <Stack key={group.code} gap={1} align="stretch">
        <p>{group.message}</p>
        <p className="text-subtle">{group.action}</p>
        <details className="text-subtle">
          <summary className="cursor-pointer">
            {group.count} {group.count === 1 ? "check" : "checks"}
            {!!group.affected.length && ` · ${group.affected.length} affected`}
          </summary>
          {!!group.affected.length && <p>{group.affected.join(", ")}</p>}
          {group.affectedTruncated && (
            <p>More groups or employees are affected.</p>
          )}
        </details>
      </Stack>
    ))}
    {result.incomplete && (
      <p className="text-subtle">
        These checks are incomplete. Ask the agent to finish checking the
        change.
      </p>
    )}
    {result.detailsTruncated && !result.incomplete && (
      <p className="text-subtle">Some check details are not shown.</p>
    )}
    {result.acceptance?.issues_truncated && (
      <p className="text-subtle">Only some check results are shown.</p>
    )}
    {result.governanceMessages.map((message) => (
      <p key={message} className="text-subtle">
        {message}
      </p>
    ))}
  </Stack>
);
